import { config } from '@/config/bzbsconfig.js'; // auto build use this
//import { config } from '@/config/bzbsconfig.dev.js';
import { config as configStg} from '@/config/bzbsconfig.stg.js';
//import { config } from '@/config/bzbsconfig.prd.js';

export default {
    install(Vue) {
        if (config.debug) {
            var runLocalEnvironment = 'dev';

            switch (runLocalEnvironment) {
                case 'dev':
                    Vue.bzbsConfig = config;
                    break;
                case 'stg':
                    Vue.bzbsConfig = configStg;
                    break;
            }
        } else {
            Vue.bzbsConfig = config;
        }
    }
}
